export var BrandResponsibility = function BrandResponsibility(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return brandResponsibilityBuilder(strictLocalize).getDescription();
    }
  };
};
var brandResponsibilityBuilder = function brandResponsibilityBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "Dg58Ac",
        defaultMessage: [{
          "type": 0,
          "value": "Règlementation en matière d'expédition internationale"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "hjwQzs",
        defaultMessage: [{
          "type": 0,
          "value": "Toutes les marques qui vendent sur Faire sont tenues de se conformer à toutes les lois, règles et réglementations en vigueur dans tous les pays et régions où elles choisissent de vendre leurs produits sur Faire."
        }]
      }), strictLocalize({
        id: "ujgpuX",
        defaultMessage: [{
          "type": 0,
          "value": "Les options concernent notamment : la sécurité des produits, les critères d'étiquetage, les tests, les avertissements, le droit d'auteur, les réglementations en matière d'importation et d'exportation et les dispositions légales en matière de protection des consommateurs."
        }]
      }), strictLocalize({
        id: "DAIwfn",
        defaultMessage: [{
          "type": 0,
          "value": "Pour déterminer si vos produits peuvent être vendus dans d'autres pays ou régions, consultez un courtier en douane ou un conseiller juridique."
        }]
      })];
    }
  };
};